import React, { useEffect, useRef, useState } from 'react';
import { FaRegUserCircle } from 'react-icons/fa';
import style from './ProfileMenu.module.scss';

const UPLOAD_URL = "https://admin.yesterdaystories.net.au/";

const ProfileMenu = ({ onLogout }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        if (!open) return;

        const handleOutside = (event) => {
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        const handleEscape = (event) => {
            if (event.key === "Escape") setOpen(false);
        };

        document.addEventListener("mousedown", handleOutside);
        document.addEventListener("touchstart", handleOutside);
        document.addEventListener("keydown", handleEscape);
        return () => {
            document.removeEventListener("mousedown", handleOutside);
            document.removeEventListener("touchstart", handleOutside);
            document.removeEventListener("keydown", handleEscape);
        };
    }, [open]);

    const handleLogout = () => {
        setOpen(false);
        onLogout && onLogout();
    };

    return (
        <div className={style.profileMenu} ref={rootRef}>
            <button
                type="button"
                className={style.trigger}
                aria-haspopup="true"
                aria-expanded={open}
                aria-label="Account menu"
                onClick={() => setOpen((prev) => !prev)}
            >
                <FaRegUserCircle />
            </button>
            {open && (
                <div className={style.panel} role="menu">
                    <a
                        href={UPLOAD_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={style.item}
                        role="menuitem"
                        onClick={() => setOpen(false)}
                    >
                        Upload a story
                    </a>
                    <button
                        type="button"
                        className={style.item}
                        role="menuitem"
                        onClick={handleLogout}
                    >
                        Logout
                    </button>
                </div>
            )}
        </div>
    );
};

export default ProfileMenu;
